module.exports = __webpack_public_path__ + "static/media/kuro-science-ill.3cf7b774.svg";